<div class="after-sales-tracker" *ngIf="hasPipeline">

  <!-- ═══ STAGE CHEVRON BAR ═══ -->
  <div class="tracker-header">
    <div class="tracker-title">
      <span class="material-icons tracker-icon">local_shipping</span>
      <span>{{ currentPipelineName || 'After-Sales Pipeline' }}</span>
      <span class="pipeline-badge">{{ stageList.length }} Stages</span>
    </div>
    <button class="history-btn" (click)="toggleHistory()">
      <span class="material-icons">history</span>
      View History
    </button>
  </div>

  <div class="stage-bar-scroll">
    <div class="stage-bar">
      <div *ngFor="let stage of stageList; let i = index" class="stage-chevron"
        [class.stage-done]="i < currentStageIndex || (i === currentStageIndex && isLastStageCompleted)"
        [class.stage-active]="i === currentStageIndex && !isLastStageCompleted"
        [class.stage-pending]="i > currentStageIndex" [attr.title]="stage.statusName"
        [style.cursor]="i <= currentStageIndex ? 'pointer' : (isCurrentStageCompleted ? 'pointer' : 'not-allowed')"
        (click)="onStageChevronClick(stage, i)">
        <span class="chevron-label">{{ stage.statusName }}</span>
        <span class="material-icons chevron-check"
          *ngIf="i < currentStageIndex || (i === currentStageIndex && isLastStageCompleted)">check</span>
      </div>
    </div>
  </div>

  <!-- ═══ CURRENT STAGE INFO CARD ═══ -->
  <div class="stage-info-card" *ngIf="currentStage">
    <div class="stage-info-grid">
      <div class="info-cell">
        <span class="info-label">Current Stage</span>
        <span class="info-value stage-name-value">{{ currentStage?.statusName || entityObject?.afterSalesStatus
          }}</span>
      </div>
      <div class="info-cell">
        <span class="info-label">Started On</span>
        <span class="info-value">{{ entityObject?.afterSalesStartedDate | date:'dd MMM yyyy' }}</span>
      </div>
      <div class="info-cell">
        <span class="info-label">Status</span>
        <span class="info-badge" [class.badge-active]="!isCurrentStageCompleted && !isLastStageCompleted"
          [class.badge-done]="isCurrentStageCompleted || isLastStageCompleted">
          {{ (isCurrentStageCompleted || isLastStageCompleted) ? 'Completed' : (currentSubStatusIndex >= 0 ?
          subStatusList[currentSubStatusIndex]?.statusName : 'In Progress') }}
        </span>
      </div>
    </div>
  </div>

  <!-- ═══ MANUAL ADVANCE / COMPLETE BUTTON ═══ -->
  <div class="substatus-section no-substatus-stage"
    *ngIf="!isLastStageCompleted && (isReadyToAdvance || (isLastStage && subStatusList.length === 0))">
    <div class="substatus-header">
      <span class="substatus-title">
        <span class="material-icons">track_changes</span>
        {{ currentStage?.statusName }} — {{ isLastStage ? 'Final Stage' : (subStatusList.length === 0 ? 'No Sub-Tasks
        Configured' : 'Ready to Advance') }}
      </span>
      <button type="button" class="update-btn advance-btn"
        style="background-color: #3f51b5; color: white; border: none;"
        (click)="isLastStage ? completePipeline() : advanceToNextStageManually()" [disabled]="isUpdating">
        <span class="material-icons">{{ isLastStage ? 'check_circle' : 'arrow_forward' }}</span>
        {{ isLastStage ? 'Complete Pipeline' : 'Move to Next Stage' }}
      </button>
    </div>
    <div style="padding: 16px 0; color: #888; font-size: 13px; text-align: center;">
      <span class="material-icons"
        style="vertical-align: middle; font-size: 18px; margin-right: 4px; color: #aaa;">info_outline</span>
      {{ isLastStage ? 'Click "Complete Pipeline" to mark the after-sales process finished.' : (subStatusList.length ===
      0 ? 'This stage has no sub-tasks. Click "Move to Next Stage" to advance.' : 'All sub-tasks are completed. Click
      "Move to Next Stage" to advance.') }}
    </div>
  </div>

  <!-- ═══ SUB-STATUS PROGRESS ═══ -->
  <div class="substatus-section" *ngIf="subStatusList.length > 0">
    <div class="substatus-header">
      <span class="substatus-title">
        <span class="material-icons">track_changes</span>
        {{ currentStage?.statusName }} Progress (Sub Status)
      </span>
      <button type="button" class="update-btn" (click)="openCurrentSubStatusDialog()"
        *ngIf="!isLastStageCompleted && !isCurrentStageCompleted">
        <span class="material-icons">edit_note</span>
        Update Status
      </button>
      <span class="completed-badge" *ngIf="isCurrentStageCompleted || isLastStageCompleted"
        style="display: inline-flex; align-items: center; gap: 4px; color: #2e7d32; font-weight: 600; font-size: 13px; background: #e8f5e9; padding: 4px 10px; border-radius: 12px;">
        <span class="material-icons" style="font-size: 16px;">check_circle</span>
        Completed
      </span>
    </div>

    <div class="substatus-track-wrap">
      <div class="substatus-track">
        <div class="track-line">
          <div class="track-fill"
            [style.width]="(subStatusList.length > 1 ? (completedSubStatusCount / (subStatusList.length - 1)) * 100 : 0) + '%'">
          </div>
        </div>
        <div class="substatus-steps">
          <div *ngFor="let sub of subStatusList; let j = index" class="substatus-step"
            [class.step-done]="isSubStatusCompletedByIndex(j) || isLastStageCompleted"
            [class.step-active]="j === currentSubStatusIndex && !isSubStatusCompletedByIndex(j) && !isLastStageCompleted"
            [class.step-pending]="j > currentSubStatusIndex && !isSubStatusCompletedByIndex(j)"
            [class.step-disabled]="!isSubStatusClickable(j) && !isSubStatusCompletedByIndex(j)"
            [style.cursor]="isSubStatusClickable(j) ? 'pointer' : 'not-allowed'" (click)="selectSubStatus(sub, j)"
            [title]="sub.statusName">
            <div class="step-dot">
              <span class="material-icons step-icon"
                *ngIf="isSubStatusCompletedByIndex(j) || isLastStageCompleted">check</span>
              <span class="step-number" *ngIf="!isSubStatusCompletedByIndex(j) && !isLastStageCompleted">{{ j + 1
                }}</span>
            </div>
            <div class="step-label">{{ sub.statusName }}</div>
            <div class="step-date" *ngIf="j === currentSubStatusIndex && entityObject?.afterSalesStartedDate">
              {{ entityObject.afterSalesStartedDate | date:'dd MMM yyyy' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ HISTORY PANEL ═══ -->
  <div class="history-panel" *ngIf="showHistory">
    <div class="history-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px">
        <span class="material-icons">history</span>
        <span>After-Sales History</span>
      </div>

      <!-- View Mode Toggle -->
      <div class="history-tabs" fxLayout="row" fxLayoutGap="6px">
        <button mat-button class="history-tab-btn" [class.active]="historyViewMode === 'timeline'"
          (click)="historyViewMode = 'timeline'">
          <span class="material-icons" style="font-size: 15px; vertical-align: middle;">timeline</span>
          Timeline
        </button>
        <button mat-button class="history-tab-btn" [class.active]="historyViewMode === 'documents'"
          (click)="historyViewMode = 'documents'">
          <span class="material-icons" style="font-size: 15px; vertical-align: middle;">folder_open</span>
          Documents ({{ allHistoryDocuments.length }})
        </button>
        <button mat-button class="history-tab-btn" [class.active]="historyViewMode === 'form-data'"
          (click)="historyViewMode = 'form-data'">
          <span class="material-icons" style="font-size: 15px; vertical-align: middle;">assignment</span>
          Form Data ({{ allHistoryFormEntries.length }})
        </button>
      </div>
    </div>

    <!-- 1. Timeline View -->
    <div *ngIf="historyViewMode === 'timeline'">
      <div *ngIf="historyList.length === 0" class="history-empty">No history found.</div>
      <div class="history-list" *ngIf="historyList.length > 0">
        <div class="history-item" *ngFor="let h of historyList; trackBy: trackByHistory">
          <div class="history-dot"></div>
          <div class="history-content">
            <span class="history-main">Changed to <strong>{{ h.toSubStatusName || h.stageName }}</strong></span>
            <span class="history-sub" *ngIf="h.changedByName">by {{ h.changedByName }}</span>
            <span class="history-date">{{ h.changedAt | date:'dd MMM yyyy, hh:mm a' }}</span>

            <!-- Notes -->
            <div class="history-note" *ngIf="h.notes">
              <span class="material-icons note-icon"
                style="font-size: 14px; vertical-align: middle;">sticky_note_2</span>
              <span style="font-style: italic; color: #666; font-size: 12px; margin-left: 4px;">{{ h.notes }}</span>
            </div>

            <!-- Documents -->
            <div class="history-docs" *ngIf="h.images && parseHistoryDocuments(h.images).length > 0"
              style="margin-top: 6px; display: flex; flex-wrap: wrap; gap: 6px;">
              <button type="button" *ngFor="let doc of parseHistoryDocuments(h.images); trackBy: trackByDocName"
                (click)="downloadDocument(getFileUrl(doc), doc)" class="timeline-doc-chip" [title]="'Download ' + doc">
                <span class="material-icons" style="font-size: 14px; width: 14px; height: 14px;">{{ getDocIcon(doc)
                  }}</span>
                <span>{{ doc }}</span>
                <span class="material-icons" style="font-size: 13px; margin-left: 2px; color: #4338ca;">download</span>
              </button>
            </div>

            <!-- Submitted Dynamic Form Field Values -->
            <div class="history-form-box" *ngIf="h.formValues && parseFormValues(h.formValues).length > 0"
              style="margin-top: 8px;">
              <div class="form-box-header"
                style="font-size: 11px; font-weight: 600; color: #4338ca; display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
                <span class="material-icons" style="font-size: 13px;">assignment</span>
                <span>Form Submission:</span>
              </div>
              <div class="form-fields-wrap" style="display: flex; flex-wrap: wrap; gap: 6px;">
                <div class="form-field-badge" *ngFor="let field of parseFormValues(h.formValues); trackBy: trackByField"
                  style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 11px; color: #334155;">
                  <span style="color: #64748b; font-weight: 500;">{{ field.label }}:</span>
                  <span style="font-weight: 600; color: #1e293b; word-break: break-all;">{{ field.value }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 2. Documents Grid View -->
    <div *ngIf="historyViewMode === 'documents'" class="history-doc-grid-container">
      <div *ngIf="allHistoryDocuments.length === 0" class="history-empty">
        <span class="material-icons"
          style="font-size: 32px; color: #cbd5e1; display: block; margin-bottom: 6px;">folder_off</span>
        No documents attached in history yet.
      </div>

      <div *ngIf="allHistoryDocuments.length > 0" class="doc-table-wrap">
        <table class="doc-grid-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Owner</th>
              <th>Stage / Sub-Status</th>
              <th>File Type</th>
              <th>Added On</th>
              <th style="text-align: center;">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of allHistoryDocuments; trackBy: trackByDoc">
              <td class="doc-name-cell">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <!-- If Image -->
                  <img *ngIf="doc.isImage || isImageDoc(doc.fileName)" width="32" height="32" [src]="doc.fileUrl"
                    style="object-fit: cover; border-radius: 4px; border: 1px solid #e2e8f0;" alt="Image">
                  <!-- If PDF -->
                  <img *ngIf="doc.isPdf || isPdfDoc(doc.fileName)" src="assets/images/pdf.png" width="32" height="32"
                    alt="PDF File">
                  <!-- If Word -->
                  <img *ngIf="doc.isWord || isWordDoc(doc.fileName)" src="assets/images/docx.png" width="32" height="32"
                    alt="DOCX File">
                  <!-- If Excel -->
                  <img *ngIf="doc.isExcel || isExcelDoc(doc.fileName)" src="assets/images/excel.png" width="32"
                    height="32" alt="Excel File">
                  <!-- If Video -->
                  <img *ngIf="doc.isVideo || isVideoDoc(doc.fileName)" src="assets/images/mp4.png" width="32"
                    height="32" alt="Video File">
                  <!-- If Audio -->
                  <img *ngIf="doc.isAudio || isAudioDoc(doc.fileName)" src="assets/images/mp3.png" width="32"
                    height="32" alt="Audio File">
                  <!-- Fallback Icon -->
                  <span class="material-icons doc-icon doc-gray"
                    *ngIf="!doc.isImage && !doc.isPdf && !doc.isWord && !doc.isExcel && !doc.isVideo && !doc.isAudio && !isImageDoc(doc.fileName) && !isPdfDoc(doc.fileName) && !isWordDoc(doc.fileName) && !isExcelDoc(doc.fileName) && !isVideoDoc(doc.fileName) && !isAudioDoc(doc.fileName)">insert_drive_file</span>

                  <span class="doc-name-text" [title]="doc.fileName"
                    (click)="downloadDocument(doc.fileUrl, doc.fileName)">
                    {{ doc.fileName }}
                  </span>
                </div>
              </td>
              <td class="uploaded-by-cell">{{ doc.uploadedBy || '—' }}</td>
              <td>
                <span class="stage-tag" *ngIf="doc.stageName">{{ doc.stageName }}</span>
                <span class="substatus-tag" *ngIf="doc.subStatusName && doc.subStatusName !== doc.stageName">{{
                  doc.subStatusName }}</span>
              </td>
              <td class="file-type-cell">{{ doc.fileTypeLabel || getFileTypeLabel(doc.fileName) }}</td>
              <td class="uploaded-date-cell">{{ doc.uploadedAt | date:'dd-MM-yyyy' }}</td>
              <td style="text-align: center;">
                <button mat-icon-button (click)="downloadDocument(doc.fileUrl, doc.fileName)" title="Download File"
                  class="doc-dl-action-btn">
                  <mat-icon style="font-size: 20px; color: #2563eb;">download</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 3. Form Data View -->
    <div *ngIf="historyViewMode === 'form-data'" class="history-form-grid-container">
      <div *ngIf="allHistoryFormEntries.length === 0" class="history-empty">
        <span class="material-icons"
          style="font-size: 32px; color: #cbd5e1; display: block; margin-bottom: 6px;">assignment_late</span>
        No dynamic form data recorded in history yet.
      </div>

      <div *ngIf="allHistoryFormEntries.length > 0" class="form-entries-list"
        style="display: flex; flex-direction: column; gap: 12px;">
        <div class="form-entry-card" *ngFor="let entry of allHistoryFormEntries; trackBy: trackByEntry"
          style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px 16px;">
          <div class="entry-header"
            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; border-bottom: 1px solid #e2e8f0; padding-bottom: 6px;">
            <div style="display: flex; gap: 6px; align-items: center;">
              <span class="stage-tag" *ngIf="entry.stageName">{{ entry.stageName }}</span>
              <span class="substatus-tag" *ngIf="entry.subStatusName && entry.subStatusName !== entry.stageName">{{
                entry.subStatusName }}</span>
            </div>
            <div style="font-size: 11px; color: #64748b;">
              <span *ngIf="entry.submittedBy" style="margin-right: 8px;">by {{ entry.submittedBy }}</span>
              <!-- <span>{{ entry.submittedAt | date:'dd MMM yyyy, hh:mm a' }}</span> -->
              <span>{{ entry.submittedAt | date:'dd MMM yyyy' }}</span>
            </div>
          </div>
          <div class="entry-fields-grid"
            style="display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 10px;">
            <div class="field-item-card" *ngFor="let f of entry.fields; trackBy: trackByField"
              style="background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; padding: 8px 12px;">
              <div
                style="font-size: 10.5px; text-transform: uppercase; color: #64748b; font-weight: 600; letter-spacing: 0.4px;">
                {{ f.label }}</div>
              <div style="font-size: 13px; font-weight: 500; color: #1e293b; margin-top: 2px; word-break: break-all;">{{
                f.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>